export const CHANGE_LOCATION = "Change Location";
export const CHANGE_DATES = "Change Dates";
